export const UPLOAD_URL = "UPLOAD_URL";
export const UPLOAD_URL_SUCCESS = "UPLOAD_URL_SUCCESS";
export const UPLOAD_URL_FAILED = "UPLOAD_URL_FAILED";

export const READ_URL = "READ_URL";
export const READ_URL_SUCCESS = "READ_URL_SUCCESS";
export const READ_URL_FAILED = "READ_URL_FAILED";

export const UPLOAD_BINARY_URL = "UPLOAD_BINARY_URL";
export const UPLOAD_BINARY_URL_SUCCESS = "UPLOAD_BINARY_URL_SUCCESS";
export const UPLOAD_BINARY_URL_FAILED = "UPLOAD_BINARY_URL_FAILED";

export const UPLOAD_GALLERY_URL = "UPLOAD_GALLERY_URL";
export const UPLOAD_GALLERY_URL_SUCCESS = "UPLOAD_GALLERY_URL_SUCCESS";
export const UPLOAD_GALLERY_URL_FAILED = "UPLOAD_GALLERY_URL_FAILED";

export const READ_GALLERY_URL = "READ_URL";
export const READ_GALLERY_URL_SUCCESS = "READ_GALLERY_URL_SUCCESS";
export const READ_GALLERY_URL_FAILED = "READ_GALLERY_URL_FAILED";

export const UPLOAD_GALLERY_BINARY_URL = "UPLOAD_GALLERY_BINARY_URL";
export const UPLOAD_GALLERY_BINARY_URL_SUCCESS =
  "UPLOAD_GALLERY_BINARY_URL_SUCCESS";
export const UPLOAD_GALLERY_BINARY_URL_FAILED =
  "UPLOAD_GALLERY_BINARY_URL_FAILED";

export const UPLOAD_VIDEO_URL = "UPLOAD_VIDEO_URL";
export const UPLOAD_VIDEO_URL_SUCCESS = "UPLOAD_VIDEO_URL_SUCCESS";
export const UPLOAD_VIDEO_URL_FAILED = "UPLOAD_VIDEO_URL_FAILED";

export const READ_VIDEO_URL = "READ_VIDEO_URL";
export const READ_VIDEO_URL_SUCCESS = "READ_VIDEO_URL_SUCCESS";
export const READ_VIDEO_URL_FAILED = "READ_VIDEO_URL_FAILED";

export const UPLOAD_VIDEO_BINARY_URL = "UPLOAD_VIDEO_BINARY_URL";
export const UPLOAD_VIDEO_BINARY_URL_SUCCESS =
  "UPLOAD_VIDEO_BINARY_URL_SUCCESS";
export const UPLOAD_VIDEO_BINARY_URL_FAILED = "UPLOAD_VIDEO_BINARY_URL_FAILED";

export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";
